import { userReducer } from '../../../redux/resources/user';

export const reducers = {
  user: userReducer,
};
